import { render, staticRenderFns } from "./NumericAnswer.vue?vue&type=template&id=518473e4&"
import script from "./NumericAnswer.vue?vue&type=script&lang=js&"
export * from "./NumericAnswer.vue?vue&type=script&lang=js&"
import style0 from "./NumericAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports